import { render } from "./MsgLeftNav.vue?vue&type=template&id=cd5fcafc&scoped=true"
import script from "./MsgLeftNav.vue?vue&type=script&lang=js"
export * from "./MsgLeftNav.vue?vue&type=script&lang=js"

import "./MsgLeftNav.vue?vue&type=style&index=0&id=cd5fcafc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd5fcafc"]])

export default __exports__